import { map, pipe, succeed, type Effect } from "@otto-ec/assets-core-utils/nano-effect";

export interface ScrollVisibilityInput {
  currentY: number;
  previousY: number;
  viewportHeight: number;
  isExtraLarge: boolean;
  isVisible: boolean;
}

const SCROLLED_UP_THRESHOLD = 20;

export function nextVisibility(input: ScrollVisibilityInput): Effect<boolean, never> {
  return pipe(
    succeed(input),
    map(({ currentY, previousY, viewportHeight, isExtraLarge, isVisible }) => {
      const scrolledDown = currentY > previousY;
      const scrolledUp = currentY < previousY - SCROLLED_UP_THRESHOLD;
      const scrolledPastThreshold = currentY > viewportHeight;

      if (isExtraLarge) {
        if (scrolledDown && scrolledPastThreshold) return true;
        if (!scrolledPastThreshold) return false;
        return isVisible;
      }

      if (scrolledUp && scrolledPastThreshold) return true;
      if (scrolledDown || (scrolledUp && !scrolledPastThreshold)) return false;
      return isVisible;
    }),
  );
}
